let cachedBasePath;

const computeBasePath = () => {
  const publicUrl = process.env.PUBLIC_URL;
  if (!publicUrl || publicUrl === "." || publicUrl === "/") {
    return "";
  }
  try {
    const url = new URL(publicUrl, "http://placeholder.local");
    const path = url.pathname.replace(/\/$/, "");
    if (path === "/" || path === "") {
      return "";
    }
    return path;
  } catch {
    if (publicUrl.startsWith("/")) {
      const sanitized = publicUrl.replace(/\/$/, "");
      return sanitized === "/" ? "" : sanitized;
    }
    return "";
  }
};

export const getBasePath = () => {
  if (typeof cachedBasePath === "string") {
    return cachedBasePath;
  }
  cachedBasePath = computeBasePath();
  return cachedBasePath;
};

export const buildInternalUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const basePath = getBasePath();
  if (!basePath) {
    return normalizedPath === "//" ? "/" : normalizedPath;
  }
  return `${basePath}${normalizedPath}`.replace(/\/{2,}/g, "/");
};

export const getAllProductsUrl = () => buildInternalUrl("/productos");

export const getHomeUrl = () => {
  const basePath = getBasePath();
  return basePath || "/";
};

export const buildHomeAnchorLink = (anchor) => {
  const normalizedAnchor = anchor.replace(/^#/, "");
  const basePath = getBasePath();
  const prefix = basePath || "";
  const separator = prefix && prefix.endsWith("/") ? "" : "/";
  return `${prefix}${separator}#${normalizedAnchor}`.replace(/\/{2,}/g, "/");
};

export const isAllProductsRoute = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const basePath = getBasePath();
  const effectiveBase = basePath && basePath !== "/" ? basePath : "";
  const normalizedPath = window.location.pathname.replace(/\/+$/, "") || "/";
  let relativePath = normalizedPath;
  if (effectiveBase && normalizedPath.startsWith(effectiveBase)) {
    relativePath = normalizedPath.slice(effectiveBase.length) || "/";
  }
  return relativePath === "/productos";
};
